const respEn = {
  instructions_va: [
    {
      id: "mBanking",
      title: "Instructions for Transfer via M banking",
      intruction: [
        {
          id: "1",
          idlevel1: "mBanking",
          title: "Access and log in to the internet banking application",
        },
        {
          id: "2",
          idlevel1: "mBanking",
          title: "Select Bank Transfer",
        },
        { id: "3", idlevel1: "internet", title: "Select destination bank" },
        {
          id: "4",
          idlevel1: "mBanking",
          title: "Enter virtual account number {get_VA}",
        },
        {
          id: "5",
          idlevel1: "mBanking",
          title:
            "The Internet Banking platform will display information about the transfer, including the destination VA number and the amount to be transferred. Make sure all information is correct before proceeding.",
        },
        {
          id: "6",
          idlevel1: "mBanking",
          title:
            "Select transfer method: Online transfer or BI-Fast. Note: If the destination VA number cannot use BI-Fast, choose the Online Transfer method.",
        },
        {
          id: "7",
          idlevel1: "mBanking",
          title: "Confirm the transaction.",
        },
      ],
    },
    {
      id: "ATM",
      title: "Instructions for Transfer via ATM",
      intruction: [
        {
          id: "1",
          idlevel1: "ATM",
          title: "Insert ATM card into the ATM machine",
        },
        {
          id: "2",
          idlevel1: "ATM",
          title: "Select Language",
        },
        { id: "3", idlevel1: "ATM", title: "Select source account" },
        {
          id: "4",
          idlevel1: "ATM",
          title: `Select "To BRI Account" option for transfer type`,
        },
        {
          id: "5",
          idlevel1: "ATM",
          title: "Enter virtual account number {get_VA}",
        },
        {
          id: "6",
          idlevel1: "ATM",
          title:
            "The ATM machine will display payment information, including the Fixed Payment VA number and the amount to be paid. Make sure this information is correct before proceeding.",
        },
        {
          id: "7",
          idlevel1: "ATM",
          title: "Confirm the transaction.",
        },
      ],
    },
    {
      id: "internet",
      title: "Instructions for Transfer via I Banking",
      intruction: [
        {
          id: "1",
          idlevel1: "internet",
          title: "Access and log in to the internet banking application",
        },
        {
          id: "2",
          idlevel1: "internet",
          title: "Select Bank Transfer",
        },
        { id: "3", idlevel1: "internet", title: "Select destination bank" },
        {
          id: "4",
          idlevel1: "internet",
          title: "Enter virtual account number {get_VA}",
        },
        {
          id: "5",
          idlevel1: "internet",
          title:
            "The Internet Banking platform will display information about the transfer, including the destination VA number and the amount to be transferred. Make sure all information is correct before proceeding.",
        },
        {
          id: "6",
          idlevel1: "internet",
          title:
            "Select transfer method: Online transfer or BI-Fast. Note: If the destination VA number cannot use BI-Fast, choose the Online Transfer method.",
        },
        {
          id: "7",
          idlevel1: "internet",
          title: "Confirm the transaction.",
        },
      ],
    },
  ],
  instructions_va_BSI: [
    {
      id: "mBanking",
      title: "Instructions for Transferring via M banking",
      intruction: [
        {
          id: "1",
          idlevel1: "mBanking",
          title: "Access and log in to the internet banking application",
        },
        {
          id: "2",
          idlevel1: "mBanking",
          title: "Select Bank Transfer",
        },
        { id: "3", idlevel1: "mBanking", title: "Select destination bank" },
        {
          id: "4",
          idlevel1: "mBanking",
          title: "Enter virtual account number {get_VA}",
        },
        {
          id: "5",
          idlevel1: "mBanking",
          title:
            "The Internet Banking platform will display information about the transfer, including the destination VA number and the amount to be transferred. Make sure all information is correct before proceeding.",
        },
        {
          id: "6",
          idlevel1: "mBanking",
          title:
            "Select transfer method: Online transfer or BI-Fast. Note: If the destination VA number cannot use BI-Fast, choose the Online Transfer method.",
        },
        {
          id: "7",
          idlevel1: "mBanking",
          title: "Confirm the transaction.",
        },
      ],
    },
    {
      id: "ATM",
      title: "Instructions for Transferring via ATM",
      intruction: [
        {
          id: "1",
          idlevel1: "ATM",
          title: "Insert your ATM card into the ATM machine"
        },
        {
          id: "2",
          idlevel1: "ATM",
          title: "Select Language"
        },
        {
          id: "3",
          idlevel1: "ATM",
          title: "Select source account"
        },
        {
          id: "4",
          idlevel1: "ATM",
          title: `Select the option "To BRI Account" on the transfer type selection`
        },
        {
          id: "5",
          idlevel1: "ATM",
          title: "Enter the virtual account number {get_VA}"
        },
        {
          id: "6",
          idlevel1: "ATM",
          title: "The ATM machine will display information about the payment, including the Fixed Payment VA number and the amount to be paid. Make sure this information is correct before proceeding."
        },
        {
          id: "7",
          idlevel1: "ATM",
          title: "Confirm transaction"
        }
      ]
    },
    {
      id: "internet",
      title: "Instructions for Transferring via I Banking",
      intruction: [
        {
          id: "1",
          idlevel1: "internet",
          title: "Access and log in to the internet banking application",
        },
        {
          id: "2",
          idlevel1: "internet",
          title: "Select Bank Transfer",
        },
        { id: "3", idlevel1: "internet", title: "Select destination bank" },
        {
          id: "4",
          idlevel1: "internet",
          title: "Enter virtual account number {get_VA}",
        },
        {
          id: "5",
          idlevel1: "internet",
          title:
            "The Internet Banking platform will display information about the transfer, including the destination VA number and the amount to be transferred. Make sure all information is correct before proceeding.",
        },
        {
          id: "6",
          idlevel1: "internet",
          title:
            "Select transfer method: Online transfer or BI-Fast. Note: If the destination VA number cannot use BI-Fast, choose the Online Transfer method.",
        },
        {
          id: "7",
          idlevel1: "internet",
          title: "Confirm the transaction.",
        },
      ],
    },
    {
      id: "bankLain",
      title: "Instructions for Transferring via Other Bank",
      intruction: [
        {
          id: "1",
          idlevel1: "bankLain",
          title: "Access the mobile banking app of another bank and log in using your account.",
        },
        {
          id: "2",
          idlevel1: "bankLain",
          title: "Select the Transfer (TF) menu.",
        },
        {
          id: "3",
          idlevel1: "bankLain",
          title: "Select Interbank Transfer.",
        },
        {
          id: "4",
          idlevel1: "bankLain",
          title: "Select the destination bank BSI (Bank Syariah Indonesia).",
        },
        {
          id: "5",
          idlevel1: "bankLain",
          title: "Enter the Virtual Account (VA) number {get_VA_BANKLAIN} in the destination account number field.",
        },
        {
          id: "6",
          idlevel1: "bankLain",
          title:
            "Review the transfer details displayed, including the recipient's name and the amount to be sent. Make sure all information is correct.",
        },
        {
          id: "7",
          idlevel1: "bankLain",
          title: "Select the online transfer method.",
        },
        {
          id: "8",
          idlevel1: "bankLain",
          title: "Enter the transfer amount as needed.",
        },
        {
          id: "9",
          idlevel1: "bankLain",
          title:
            "Confirm the transaction by entering your PIN/OTP. Save the transfer receipt as a reference.",
        },
      ],
    },
  ],
  instructions_va_BSI_POLTEKAPP: [
    {
      id: "mBanking",
      title: "Instructions for Transferring via M banking",
      intruction: [
        {
          id: "1",
          idlevel1: "mBanking",
          title: "Log in to BYOND by BSI.",
        },
        {
          id: "2",
          idlevel1: "mBanking",
          title: "Select the Pay/Buy menu.",
        },
        {
          id: "3",
          idlevel1: "mBanking",
          title: "Select the Academic menu.",
        },
        {
          id: "4",
          idlevel1: "mBanking",
          title: `Enter biller code "2045" or type the biller name "Politeknik APP Jakarta".`,
        },
        {
          id: "5",
          idlevel1: "mBanking",
          title: "Enter the payment number {get_VA}.",
        },
        {
          id: "6",
          idlevel1: "mBanking",
          title: "The billing validation screen will appear.",
        },
        {
          id: "7",
          idlevel1: "mBanking",
          title: "Click confirm and enter your PIN.",
        },
        {
          id: "8",
          idlevel1: "mBanking",
          title: "Alhamdulillah, your payment was successful.",
        },
      ],
    },
    {
      id: "ATM",
      title: "Instructions for Transferring via ATM BSI",
      intruction: [
        {
          id: "1",
          idlevel1: "ATM",
          title: "Insert your debit card.",
        },
        {
          id: "2",
          idlevel1: "ATM",
          title: "Enter your ATM PIN.",
        },
        {
          id: "3",
          idlevel1: "ATM",
          title: "Select Cash Withdrawal/Other Transactions.",
        },
        {
          id: "4",
          idlevel1: "ATM",
          title: "Select Main Menu.",
        },
        {
          id: "5",
          idlevel1: "ATM",
          title: "Select Pay & Buy.",
        },
        {
          id: "6",
          idlevel1: "ATM",
          title: "Select Academic/Institution.",
        },
        {
          id: "7",
          idlevel1: "ATM",
          title: "Enter the payment code by typing 2045{get_VA}",
        },
        {
          id: "8",
          idlevel1: "ATM",
          title: `Select "Next" to confirm.`,
        },
        {
          id: "9",
          idlevel1: "ATM",
          title: "Alhamdulillah, your payment was successful.",
        },
      ],
    },
    {
      id: "internet",
      title: "Instructions for Transferring via BSI Net Banking",
      intruction: [
        {
          id: "1",
          idlevel1: "internet",
          title: "Log in to BSI Net Banking.",
        },
        {
          id: "2",
          idlevel1: "internet",
          title: "Select the Payment menu.",
        },
        {
          id: "3",
          idlevel1: "internet",
          title: "Select Institution.",
        },
        {
          id: "4",
          idlevel1: "internet",
          title: `Select biller name "Politeknik APP Jakarta".`,
        },
        {
          id: "5",
          idlevel1: "internet",
          title: "Enter {get_VA}",
        },
        {
          id: "6",
          idlevel1: "internet",
          title: "The billing validation screen will appear.",
        },
        {
          id: "7",
          idlevel1: "internet",
          title: "Input your Token Number (Request SMS) and Authorization PIN.",
        },
        {
          id: "8",
          idlevel1: "internet",
          title: `Then select "Next" to confirm.`,
        },
        {
          id: "9",
          idlevel1: "internet",
          title: "Alhamdulillah, your payment was successful.",
        },
      ],
    },
    {
      id: "bankLain",
      title: "Instructions for Transferring via Other Bank",
      intruction: [
        {
          id: "1",
          idlevel1: "bankLain",
          title: "Access the mobile banking app of another bank and log in using your account.",
        },
        {
          id: "2",
          idlevel1: "bankLain",
          title: "Select the Transfer (TF) menu.",
        },
        {
          id: "3",
          idlevel1: "bankLain",
          title: "Select Interbank Transfer.",
        },
        {
          id: "4",
          idlevel1: "bankLain",
          title: "Select the destination bank BSI (Bank Syariah Indonesia).",
        },
        {
          id: "5",
          idlevel1: "bankLain",
          title: "Enter the Virtual Account (VA) number {get_VA_BANKLAIN} in the destination account number field.",
        },
        {
          id: "6",
          idlevel1: "bankLain",
          title:
            "Review the transfer details displayed, including the recipient's name and the amount to be sent. Make sure all information is correct.",
        },
        {
          id: "7",
          idlevel1: "bankLain",
          title: "Select the online transfer method.",
        },
        {
          id: "8",
          idlevel1: "bankLain",
          title: "Enter the transfer amount as needed.",
        },
        {
          id: "9",
          idlevel1: "bankLain",
          title:
            "Confirm the transaction by entering your PIN/OTP. Save the transfer receipt as a reference.",
        },
      ],
    },
    {
      id: "teller",
      title: "Instructions for Transferring via BSI Branch Teller",
      intruction: [
        {
          id: "1",
          idlevel1: "teller",
          title: "Fill out the Bill Payment Slip:\n- Source Account Number (for overbooking) or Cash Deposit (walk-in Teller).\n- Name of Bill Owner.\n- Code 2045{get_VA} and biller name Politeknik APP Jakarta\n- Payment Number.\n- Payment Amount.",
        },
        {
          id: "2",
          idlevel1: "teller",
          title: "Sign the Bill Payment Slip, then hand it to the BSI Teller.",
        },
        {
          id: "3",
          idlevel1: "teller",
          title: "The Teller will confirm the payment amount.",
        },
        {
          id: "4",
          idlevel1: "teller",
          title: "Alhamdulillah, your payment was successful.",
        },
      ],
    },
  ],
}

export default respEn